/**
 * Die Seitenregel der Torte (docs/mangelkatalog-vertrag.md): je Seite
 * höchstens 8 Einträge; folgen weitere, ist das 9. Stück „Sonstiges“ und
 * blättert weiter. Die letzte Seite hat kein „Sonstiges“.
 * 9 → 8 + S | 1 · 16 → 8 + S | 8 · 17 → 8 + S | 8 + S | 1.
 */

export const PRO_SEITE = 8;

/** max(1, ceil(n / 8)); Unsinn (negativ, NaN) zählt als 0 Einträge. */
export function seitenAnzahl(n: number): number {
    const anzahl = Number.isFinite(n) && n > 0 ? Math.floor(n) : 0;
    return Math.max(1, Math.ceil(anzahl / PRO_SEITE));
}

export interface Seite<T> {
    eintraege: T[];
    /** Geklemmter Seitenindex (0-basiert). */
    index: number;
    /** Seitenzahl gesamt. */
    anzahl: number;
    /** Es folgt eine weitere Seite → Stück 9 ist „Sonstiges“. */
    weiter: boolean;
    /** Einträge NACH dieser Seite (für „Sonstiges (+n)“). */
    rest: number;
}

/** Schneidet Seite `index` aus der Liste; der Index wird auf 0 … anzahl−1 geklemmt. */
export function seiteSchneiden<T>(liste: readonly T[], index: number): Seite<T> {
    const n = liste?.length ?? 0;
    const anzahl = seitenAnzahl(n);
    const roh = Number.isFinite(index) ? Math.floor(index) : 0;
    const i = Math.min(Math.max(0, roh), anzahl - 1);
    const start = i * PRO_SEITE;
    return {
        eintraege: (liste ?? []).slice(start, start + PRO_SEITE),
        index: i,
        anzahl,
        weiter: i < anzahl - 1,
        rest: Math.max(0, n - start - PRO_SEITE),
    };
}
